/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CarveOutTrackingListEntry } from './CarveOutTrackingListEntry';
import {
    CarveOutTrackingListEntryFromJSON,
    CarveOutTrackingListEntryFromJSONTyped,
    CarveOutTrackingListEntryToJSON,
    CarveOutTrackingListEntryToJSONTyped,
} from './CarveOutTrackingListEntry';

/**
 * 
 * @export
 * @interface FindAllCarveOutTrackingResponse
 */
export interface FindAllCarveOutTrackingResponse {
    /**
     * 
     */
    data: Array<CarveOutTrackingListEntry>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
    /**
     * User lookup map keyed by user_id. Each value matches the LeadAssignmentUser shape.
     */
    users_sidecar?: { [key: string]: any; };
}

/**
 * Check if a given object implements the FindAllCarveOutTrackingResponse interface.
 */
export function instanceOfFindAllCarveOutTrackingResponse(value: object): value is FindAllCarveOutTrackingResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function FindAllCarveOutTrackingResponseFromJSON(json: any): FindAllCarveOutTrackingResponse {
    return FindAllCarveOutTrackingResponseFromJSONTyped(json, false);
}

export function FindAllCarveOutTrackingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCarveOutTrackingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(CarveOutTrackingListEntryFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
        'users_sidecar': json['users_sidecar'] == null ? undefined : json['users_sidecar'],
    };
}

export function FindAllCarveOutTrackingResponseToJSON(json: any): FindAllCarveOutTrackingResponse {
    return FindAllCarveOutTrackingResponseToJSONTyped(json, false);
}

export function FindAllCarveOutTrackingResponseToJSONTyped(value?: FindAllCarveOutTrackingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(CarveOutTrackingListEntryToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
        'users_sidecar': value['users_sidecar'],
    };
}

